'use strict';

const Raven = require('raven-js');
const _     = require('lodash');
const Connection = require('./Connection');

const getSentryLogger = (isPro, dsn, tags) => {

    const environment = isPro ? 'Production' : 'Development';

    // Any falsey value sent as first param won't enable Sentry
    return Raven.config(isPro ? dsn : '', {
        autoBreadcrumbs: true,
        captureUnhandledRejections: false,
        environment,
        tags,
        // White list inbenta URLs
        whitelistUrls: [
            /backstage[0-9]+.inbenta.com/
        ],
    });
};

/**
 * A logging utility for showing messages in the client.
 * Deactivated in production environments.
 */
class Logger {
    /**
     * Don't call it directly, just .log or .error your messages.
     * Creates a new Logger instance active or not depending on the current env.
     * @private
     */
    constructor () {
        this.isPro = (process.env.IS_PRO) ? true : false;
        this.available = console ? true : false;
        this.active = !this.isPro && this.available;
    }

    configure (tags) {
        this.sentryLogger = getSentryLogger(this.isPro, process.env.sentryDsn, tags);
    }

    /**
     * Logs a message into the browser console as a regular message
     * Send as many arguments as you wish, all of them will be logged.
     */
    log () {
        if (this.active) {
            for (let arg of arguments) {
                console.log(arg);
            }
        }
    }

    /**
     * Logs a message into the browser console as a warning
     * Send as many arguments as you wish, all of them will be logged.
     */
    warn () {
        if (this.active) {
            const warn = console.warn || console.log;
            for (let arg of arguments) {
                warn(arg);
            }
        }
    }

    /**
     * Logs a message into the browser console as an error
     * Send as many arguments as you wish, all of them will be logged.
     */
    error (err, context = {}, tags = {}) {
        context.ping = Connection.ping;
        context.timeDifferenceWithServer = Connection.timeDifferenceWithServer;
        
        if (this.isPro) {
            if (this.available) {
                console.log('Oops, something went wrong');
            }

            // Try to convert err to a real Error
            if (!(err instanceof Error)) {
                // pass the error as an extra property
                context.error = err;

                // Extract message
                const errorMessage = err.message || _.get(err, 'error.message') || 'Unknown error';
                err = new Error(errorMessage);
            }

            this.sentryLogger.captureException(err, { extra: context, tags });

        } else if (this.active) {
            const error = console.error || console.log;
            for (let arg of arguments) {
                error(arg);
            }
        }
    }
}

module.exports = new Logger();


// WEBPACK FOOTER //
// ./src/Logger.js